export default __webpack_public_path__ + "static/media/putting-money-into-cpf.f3b33422.svg";